import useGetMyPermissionsFromCache from '~/features/user/hooks/useGetMyPermissionsFromCache'
import { EAccessLevel, EBaseAccess, ECapability } from '~/features/user/models'

export default function useCapabilities() {
  const { data, isSuccess, isError } = useGetMyPermissionsFromCache()

  const isLoaded = isSuccess || isError
  const baseAccess = data?.baseAccess ?? EBaseAccess.full
  const capabilities = data?.capabilities ?? {}

  return {
    baseAccess,
    capabilities,
    orgId: data?.orgId ?? null,
    isLoaded,
    isError,
    canRead: (capability: ECapability) =>
      isLoaded &&
      (baseAccess === EBaseAccess.full ||
        capabilities[capability] === EAccessLevel.read ||
        capabilities[capability] === EAccessLevel.edit),
    canEdit: (capability: ECapability) =>
      isLoaded &&
      (baseAccess === EBaseAccess.full ||
        capabilities[capability] === EAccessLevel.edit),
  }
}
